<template>
    <v-app>
        <v-main>
            <slot />
        </v-main>

        <t-notifications></t-notifications>
    </v-app>
</template>

<script>
import TNotifications from "./TNotifications";

export default {
    components: { TNotifications },
};
</script>
